import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Lazy load language files to reduce initial bundle and main-thread work
const loadLanguage = async (lang: string) => {
  if (lang === 'fr') {
    return (await import('./locales/fr.json')).default;
  }
  return (await import('./locales/en.json')).default;
};

// Get initial language from localStorage or default to fr
const getInitialLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('fps-language');
    if (stored && ['fr', 'en'].includes(stored)) return stored;
  }
  return 'fr';
};

const initialLang = getInitialLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    lng: initialLang,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'fps-language',
    },
    partialBundledLanguages: true,
  });

// Load initial language immediately
loadLanguage(initialLang).then(translations => {
  i18n.addResourceBundle(initialLang, 'translation', translations, true, true);
});

// Preload other language in idle time
if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(() => {
    const otherLang = initialLang === 'fr' ? 'en' : 'fr';
    loadLanguage(otherLang).then(translations => {
      i18n.addResourceBundle(otherLang, 'translation', translations, true, true);
    });
  });
}

export default i18n;
